module.exports = __webpack_public_path__ + "static/media/ref3.31cdc800.jpg";